/*
  Viveane - Silent add to cart.
  Adding a product from a collection card or the Quick View no longer opens the
  cart drawer/popup, does not refresh or redirect: it stays on the page and shows
  a small auto-dismissing toast instead. The cart badge still updates (handled by
  the theme's own add flow). The header cart-icon still opens the drawer normally.

  Implementation: the theme funnels every post-add drawer/popup through
  cart-notification.open(). We wrap that single method so an add-triggered open
  becomes a toast, while a genuine header cart-icon click still opens the drawer.

  Reversible: delete the <script src=".../viv-silent-add.js"> line in
  snippets/scripts-tag.liquid to restore the theme default behaviour.
*/
(function () {
  var lastIconClick = 0;

  // Record header cart-icon clicks in the capture phase (before the theme's own
  // handler), so a real icon click can still open the drawer.
  document.addEventListener(
    "click",
    function (e) {
      if (e.target && e.target.closest && e.target.closest(".minicart__action")) {
        lastIconClick = Date.now();
      }
    },
    true
  );

  function vivAddedToast() {
    var msg =
      (window.cartStrings && window.cartStrings.item_added) ||
      (window.variantStrings && window.variantStrings.addSuccess) ||
      "Added to cart";
    if (typeof showToast !== "function") return;
    // Singleton: never stack duplicate toasts on rapid consecutive adds.
    var tc = document.getElementById("toast-container");
    if (tc) {
      tc.querySelectorAll(".viv-add-toast").forEach(function (t) {
        t.remove();
      });
    }
    showToast(
      '<span class="viv-add-toast__check" aria-hidden="true">✓</span>' +
        '<span class="viv-add-toast__msg">' + msg + "</span>",
      2800,
      "viv-add-toast"
    );
    // Accessibility: announce politely without stealing focus.
    var el = document.querySelector("#toast-container .viv-add-toast");
    if (el) {
      el.setAttribute("role", "status");
      el.setAttribute("aria-live", "polite");
    }
  }

  // The add flow re-opens the in-drawer upsell (~800ms later); keep it closed
  // while the drawer itself stays closed on a silent add.
  function suppressRecommend() {
    var end = Date.now() + 1600;
    (function tick() {
      var rec = document.querySelector(".cart-recommend");
      if (rec) rec.classList.remove("open", "block");
      if (Date.now() < end) setTimeout(tick, 150);
    })();
  }

  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined("cart-notification").then(function () {
      var CN = customElements.get("cart-notification");
      if (!CN || CN.prototype.__vivSilentPatched) return;
      CN.prototype.__vivSilentPatched = true;

      var origOpen = CN.prototype.open;
      CN.prototype.open = function () {
        // Header cart-icon click within the last moment -> normal drawer/popup.
        if (Date.now() - lastIconClick < 1200) {
          return origOpen.apply(this, arguments);
        }
        // Otherwise this open() came from add-to-cart -> stay on page + toast.
        vivAddedToast();
        suppressRecommend();
      };
    });
  }
})();
